import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import Props from '@components/Props';
export const _frontmatter = {
  "name": "BackToTop",
  "menu": "Components",
  "route": "/components/back-to-top",
  "description": "The API documentation of the BackToTop React component. Play around with demos and check out its props."
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1>{`BackToTop`}</h1>
    <p>{`This is the component you can see at the bottom-right corner of your window when you scroll down. Its default behavior doesn't
require any prop, so you can use it straight of the box. It will appear automatically on the bottom-right corner when the page is scrolled,
and it will scroll back smoothly to the top of the page when you click on it.`}</p>
    <p>{`You can cutomize the height from which the Button will apear upon scrolling by overriding the `}<inlineCode parentName="p">{`mixins.backToTop.startHeight`}</inlineCode>{` property from the `}<strong parentName="p">{`theme`}</strong>{`.`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Note:`}</strong>{` clicking on the button in the stories will bring you back to the top of the window ;)`}</p>
    </blockquote>
    <h2>{`Default`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<BackToTop />
`}</code></pre>
    <h2>{`Small`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live
<BackToTop size="small" />
`}</code></pre>
    <h2>{`Extended`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// live-extended
<ExtendedBackToTop />
`}</code></pre>
    <h2>{`Props`}</h2>
    <p>{`This component extends Material's UI `}<inlineCode parentName="p">{`<Fab>`}</inlineCode>{` component so you can use all its props. Check out its `}<a parentName="p" {...{
        "href": "https://material-ui.com/api/fab/"
      }}>{`Api`}</a>{`. It doesn't require any other prop.`}</p>
    <Props of="BackToTop" mdxType="Props" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      